import { Grid } from '@mui/material';

import ReasonsList from './reasons-list';
import TopReasons from './top-reasons';

const DashboardReasons = () => {
  return (
    <Grid
      container
      sx={{ width: '100%', mt: '2rem', display: 'flex', justifyContent: 'space-between' }}
    >
      <Grid
        item
        md={5.9}
        xs={12}
        sx={{
          background: '#ffffff',
          p: '2rem',
          border: '1px solid #00000030',
          borderRadius: '0.5rem',
          mt: { md: 0, xs: '2rem' },
        }}
      >
        <TopReasons />
      </Grid>
      <Grid
        item
        md={5.9}
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          background: '#ffffff',
          p: '2rem',
          border: '1px solid #00000030',
          borderRadius: '0.5rem',
          marginY: { md: 0, xs: '2rem' },
        }}
      >
        <ReasonsList />
      </Grid>
    </Grid>
  );
};

export default DashboardReasons;
